module.exports = __webpack_public_path__ + "img/__1.ef1577a0.png";